import componentHelper from '../../modules/component_helper.js';

angular.module('vastdesk').
  component('clearlineRtdSignalTargetingToggle',  {
    bindings: {
      formName: '@',
      formId: '@',
      clearlineRtdSignalsEnabled: '<',
      toggleClass: '@'
    },
    template: require("../templates/clearlineRtdSignalTargetingToggle.html"),
    controllerAs: '$clearlineRtdSignalTargetingToggleCtrl',
    controller: [function() {

      var self = this;

      this.allCustomOptions = componentHelper.allCustomOptions();

      this.setClearlineRtdSignalsEnabled = function(value) {
        self.clearlineRtdSignalsEnabled = value;

        $('.' + self.toggleClass).toggleClass('hidden', !value);
      };

      this.$onInit = function() {
        self.setClearlineRtdSignalsEnabled(self.clearlineRtdSignalsEnabled);
      };
    }]
});
